export { default as CredibilityCarousel } from './CredibilityCarousel';
export { default as CredibilityItem } from './CredibilityItem';
export {
  credibilityCarouselAdapter,
  careersCredibilityCarouselAdapter,
  credibilityItemAdapter,
} from './adapter';
